import React, { useRef } from "react"
import Layout from "../components/layout"
import Image from "../components/image"
import SubNavigation from "../components/sub-navigation"
import ScrollSlideshow from "../components/scroll-slideshow"
import ReadNext from "../components/read-next"

export default function Home() {
  const mainContent = useRef()

  return (
    <Layout>
      <SubNavigation id="A Year Like No Other" />
      <ScrollSlideshow contentRef={mainContent} />
      <span className="anchor" id="message" />
      <section className="util__on-top" ref={mainContent}>
        <div className="container container--large t__home__message">
          <header>
            <h2 className="title--secondary title--uppercase">
              Message from the managing director
            </h2>
          </header>
          <p>Dear Reader,</p>
          <p>
            This year, as the world faced a crisis like no other, the IMF and
            its members swung into action.
          </p>
          <p>
            National governments took bold steps to save lives and put a floor
            under the world economy, with nearly $12 trillion in fiscal actions
            and about $7.5 trillion in monetary actions.
          </p>
          <p>
            The package of measures endorsed as part of the quota review
            approved by the Board of Governors in February 2020 preserves our
            financial firepower. These measures include the doubling of the New
            Arrangements to Borrow and a new round of bilateral borrowing
            arrangements, which are expected to be effective in January 2021.
          </p>
          <p>
            Member countries also stepped up with essential contributions to our
            Catastrophe Containment and Relief Trust and Poverty Reduction and
            Growth Trust.{" "}
          </p>
          <p>
            These resources have allowed the IMF to commit over $100 billion to
            help members in need since the pandemic began. This includes
            providing our low-income members with much-needed debt relief,
            extended until April 2021, and concessional lending—including about
            10 times more such lending since the crisis hit than we usually
            disburse in a year. Our response was comprehensive, supporting both
            members that entered the crisis with vulnerabilities such as high
            debt and those that have good fundamentals but needed buffers.
          </p>
          <p>
            In response to the crisis, we quickly focused on our members’ most
            critical needs. We streamlined our procedures and rapidly embraced
            remote work to speed up decision-making, policy discussions,
            technical assistance, and training. We created a policy tracker
            summarizing the key economic responses of 196 economies, because
            sharing information, data, and analysis is a unique way we can add
            value for our members.{" "}
          </p>
          <p>
            While the IMF has taken unprecedented action, the outlook remains
            uncertain. Countries now face a long ascent that will be difficult,
            uneven, uncertain, and prone to setbacks.{" "}
          </p>
          <p>
            With substantial space in our $1 trillion lending capacity, the IMF
            is ready to help even more. Working with our members—now numbering
            190 with the addition of Andorra—we can build a recovery that is
            more resilient and inclusive for all.
          </p>
          <p>
            This <i>Annual Report</i> reflects the policy advice, lending, and
            capacity development work of the Executive Board and staff to help
            our member countries before and during the pandemic—with a focus on
            policies for people that recognize the impact of macroeconomic
            policies on individuals.{" "}
          </p>
          <p>
            This report also highlights how we have continued to deepen our work
            on debt sustainability, governance and the control of corruption,
            social spending, financial technology and digital money, and climate
            change. Action in many of these areas offers the potential for a
            transformational recovery through job-rich growth that benefits all.
          </p>
          <div className="t__home__message__byline">
            <Image
              path="home/kristalina.jpg"
              alt="Kristalina Georgieva"
              className="t__home__message__byline__image"
            />
            <div className="t__home__message__byline__signature">
              <Image
                path="home/kristalina_signature.jpg"
                alt="Kristalina Georgieva's Signature"
              />
              <h3>Kristalina Georgieva</h3>
              <span className="title--meta title--light">
                Managing Director
              </span>
            </div>
          </div>
        </div>
        <ReadNext sectionID="spotlights" pageID="covid-19" />
      </section>
    </Layout>
  )
}
